import { render, staticRenderFns } from "./bFloorShops.vue?vue&type=template&id=7659fa7c&scoped=true"
import script from "./bFloorShops.vue?vue&type=script&lang=js"
export * from "./bFloorShops.vue?vue&type=script&lang=js"
import style0 from "./bFloorShops.vue?vue&type=style&index=0&id=7659fa7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7659fa7c",
  null
  
)

export default component.exports